/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-21 12:19:16
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-25 10:35:12
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Rate/index.tsx
 */
import { Rate } from 'antd';
import React from 'react';
import css from './css.module.less';

const _Rate = (props) => {
  const { hasText, customText, value = 0, count = 5, ...rest } = props;
  const _value = Math.round(value);
  return (
    <div className={css.container}>
      <Rate value={_value} count={count} {...rest} />
      {hasText && (
        <div className={css.ratingText}>
          {customText || value + '/' + count}
        </div>
      )}
    </div>
  );
};
export default _Rate;
